import styles from './FeriasUniversitarias.module.css';

const FeriasUniversitarias = () => {
    return(
        <div className={styles.container}>
            <div className={styles.wrapper}>
                <div className={styles.content}>
                    <h2>Ferias universitarias</h2>
                    <p>¡Asiste a la universidad!</p>
                    <p>Consulta las fechas y sedes en las cuales se estarán llevando a cabo las ferias universitarias. Toma en cuenta que asistir a estos eventos te permitirá tener un acercamiento a las universidades de tu interés, en el que podrás recibir información detallada y resolver dudas.</p>

                    <h1>Próximamente</h1>
                </div>
            </div>
        </div>
    );
}

export default FeriasUniversitarias;